var render, staticRenderFns
import script from "./ib-field-date.vue?vue&type=script&lang=js&"
export * from "./ib-field-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ib-field-date.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/dev39a/aleggett/thgit/web.app/lib.common/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f9a64c')) {
      api.createRecord('70f9a64c', component.options)
    } else {
      api.reload('70f9a64c', component.options)
    }
    
  }
}
component.options.__file = "src/components/form/ib-field-date.vue"
export default component.exports